import { useEffect, useState, useCallback } from "react";
import { IGenericResearchQueriesData } from "../types/ResearchQueries";
import { getResourcePaginatedList } from "../services/resourcesService";
import { IPaginatedProps } from "../types";
import { getResearchQueriesList } from "../services/ResearchQueriesService";

interface IUseFetchGenericResearchQueries extends IPaginatedProps {
  statusFilter?: string;
  genericResearchQueryId?: string | number;
}

const useFetchPaginatedGenericResearchQueries = ({
  currentDomainId,
  setIsLoading,
  page,
  pSize,
  statusFilter,
  genericResearchQueryId,
}: IUseFetchGenericResearchQueries) => {
  const [genericResearchQueriesData, setGenericResearchQueriesData] = useState<
    IGenericResearchQueriesData[]
  >([]);
  const [refetchTrigger, setRefetchTrigger] = useState(0);

  const refetch = useCallback(() => {
    setRefetchTrigger((prev) => prev + 1);
  }, []);

  useEffect(() => {
    setIsLoading(true);
    const getGenericResearchQueriesData = async () => {
      try {
        // Map statusFilter to isActive parameter
        const isActive =
          statusFilter === "Active"
            ? "true"
            : statusFilter === "Inactive"
            ? "false"
            : "all";

        const result: IGenericResearchQueriesData[] =
          await getResearchQueriesList({
            page,
            pSize,
            isActive,
            genericResearchQueryId,
          });
        setGenericResearchQueriesData(result);
      } catch (err) {
        setGenericResearchQueriesData([]);
      } finally {
        setIsLoading(false);
      }
    };
    getGenericResearchQueriesData();
  }, [
    currentDomainId,
    page,
    pSize,
    statusFilter,
    genericResearchQueryId,
    refetchTrigger,
  ]);

  return [genericResearchQueriesData, refetch] as const;
};

export default useFetchPaginatedGenericResearchQueries;
